(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lnpdInitialized === 'true') return;
    root.dataset.lnpdInitialized = 'true';

    var form = root.querySelector('.lnpd-form');
    var variantInput = root.querySelector('[data-lnpd-variant-id]');
    var variantsNode = root.querySelector('[data-lnpd-variants]');
    var addButton = root.querySelector('[data-lnpd-add]');
    var addLabel = root.querySelector('[data-lnpd-add-label]');
    var priceNode = root.querySelector('[data-lnpd-price]');
    var compareNode = root.querySelector('[data-lnpd-compare]');
    var stockNode = root.querySelector('[data-lnpd-stock]');
    var stickyPrice = root.querySelector('[data-lnpd-sticky-price]');
    var stickyButton = root.querySelector('[data-lnpd-sticky-submit]');
    var sizing = root.querySelector('product-sizing');
    var dynamicCheckout = root.querySelector('.lnpd-dynamic');
    var variants = [];

    try {
      variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    var currentVariant = variants.find(function (variant) {
      return String(variant.id) === String(root.dataset.selectedVariantId);
    }) || variants[0];
    var selections = currentVariant ? currentVariant.options.slice() : [];

    function moneyText(variant) {
      return variant && variant.priceText ? variant.priceText : '';
    }

    function syncSticky() {
      if (!stickyButton) return;
      var unavailable = !currentVariant || !currentVariant.available;
      stickyButton.disabled = unavailable;
      if (unavailable) {
        stickyButton.textContent = 'Sold out';
      } else if (addButton && addButton.disabled) {
        stickyButton.textContent = root.dataset.sizingRequired === 'true' ? 'Choose your size' : 'Unavailable';
      } else {
        stickyButton.textContent = 'Add to cart';
      }
    }

    function sizingIsValid() {
      if (root.dataset.sizingRequired !== 'true') return true;
      if (!sizing) return false;
      if (typeof sizing.isValid === 'function') {
        try { return sizing.isValid(); } catch (error) {}
      }
      return Boolean(sizing.querySelector('[data-size-radio]:checked:not([disabled])'));
    }

    function setBooleanAttribute(element, name, enabled) {
      if (!element) return;
      if (enabled && !element.hasAttribute(name)) element.setAttribute(name, '');
      if (!enabled && element.hasAttribute(name)) element.removeAttribute(name);
    }

    function syncPurchaseState() {
      var unavailable = !currentVariant || !currentVariant.available;
      var sizingLocked = root.dataset.sizingRequired === 'true' && !sizingIsValid();

      if (addButton) {
        if (unavailable && addButton.dataset.variantLocked !== 'true') addButton.dataset.variantLocked = 'true';
        else if (!unavailable && addButton.dataset.variantLocked) delete addButton.dataset.variantLocked;
        if (sizingLocked && addButton.dataset.sizingLocked !== 'true') addButton.dataset.sizingLocked = 'true';
        else if (!sizingLocked && addButton.dataset.sizingLocked) delete addButton.dataset.sizingLocked;

        var shouldDisable = unavailable || sizingLocked;
        if (addButton.disabled !== shouldDisable) addButton.disabled = shouldDisable;
        if (shouldDisable) addButton.setAttribute('aria-disabled', 'true');
        else addButton.removeAttribute('aria-disabled');
      }

      if (dynamicCheckout) {
        var checkoutLocked = unavailable || sizingLocked;
        dynamicCheckout.classList.toggle('ps-checkout-locked', checkoutLocked);
        dynamicCheckout.setAttribute('aria-disabled', String(checkoutLocked));
        dynamicCheckout.inert = checkoutLocked;
        setBooleanAttribute(dynamicCheckout, 'data-sizing-checkout-locked', sizingLocked);
        dynamicCheckout.querySelectorAll('button').forEach(function (button) {
          button.disabled = checkoutLocked;
        });
      }

      syncSticky();
    }

    function focusVariantMedia(variant) {
      if (!variant || !variant.featuredMediaId || window.matchMedia('(min-width: 768px)').matches) return;
      var media = root.querySelector('[data-media-id="' + variant.featuredMediaId + '"]');
      if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    function updateVariant(variant, updateUrl) {
      currentVariant = variant || null;
      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.dataset.variantLocked = 'true';
          addButton.setAttribute('aria-disabled', 'true');
        }
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stockNode) {
          stockNode.classList.add('is-soldout');
          stockNode.lastChild.textContent = ' Unavailable';
        }
        syncSticky();
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (form) form.dataset.variantAvailable = String(Boolean(variant.available));
      if (priceNode) priceNode.textContent = moneyText(variant);
      if (stickyPrice) stickyPrice.textContent = moneyText(variant);
      if (compareNode) {
        var showCompare = variant.compareAtPrice > variant.price;
        compareNode.textContent = showCompare ? variant.compareAtText : '';
        compareNode.classList.toggle('is-hidden', !showCompare);
      }
      if (stockNode) {
        stockNode.classList.toggle('is-soldout', !variant.available);
        stockNode.lastChild.textContent = variant.available ? ' In stock' : ' Sold out';
      }
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (addButton) {
        if (!variant.available) {
          addButton.disabled = true;
          addButton.dataset.variantLocked = 'true';
          addButton.setAttribute('aria-disabled', 'true');
        } else if (!sizing) {
          addButton.disabled = false;
          delete addButton.dataset.variantLocked;
          addButton.removeAttribute('aria-disabled');
        }
      }

      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { sectionId: root.dataset.sectionId, variant: variant }
      }));

      if (updateUrl && variant.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }
      focusVariantMedia(variant);
      window.setTimeout(syncPurchaseState, 0);
    }

    root.querySelectorAll('[data-lnpd-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = Number(button.dataset.optionPosition) - 1;
        selections[position] = button.dataset.value;
        var fieldset = button.closest('.lnpd-option');
        fieldset.querySelectorAll('[data-lnpd-option]').forEach(function (sibling) {
          sibling.setAttribute('aria-pressed', String(sibling === button));
        });
        var selectedLabel = fieldset.querySelector('[data-lnpd-selected-option]');
        if (selectedLabel) selectedLabel.textContent = button.dataset.value;
        var match = variants.find(function (variant) {
          return variant.options.every(function (value, index) { return value === selections[index]; });
        });
        updateVariant(match, true);
      });
    });

    root.querySelectorAll('[data-lnpd-accordion]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', String(!expanded));
        button.closest('.lnpd-accordion').classList.toggle('is-open', !expanded);
        button.querySelector('span').textContent = expanded ? '+' : '−';
        if (panel) panel.hidden = expanded;
      });
    });

    var quantity = root.querySelector('[data-lnpd-quantity] input');
    root.querySelector('[data-lnpd-quantity-minus]')?.addEventListener('click', function () {
      var minimum = Number(quantity.min || 1);
      quantity.value = Math.max(minimum, Number(quantity.value || minimum) - 1);
    });
    root.querySelector('[data-lnpd-quantity-plus]')?.addEventListener('click', function () {
      quantity.value = Number(quantity.value || 1) + 1;
    });

    var wishlistButton = root.querySelector('[data-lnpd-wishlist]');
    if (wishlistButton) {
      var wishlistKey = 'lunarness:wishlist:' + root.dataset.productId;
      try { wishlistButton.setAttribute('aria-pressed', String(localStorage.getItem(wishlistKey) === 'true')); } catch (error) {}
      wishlistButton.addEventListener('click', function () {
        var next = wishlistButton.getAttribute('aria-pressed') !== 'true';
        wishlistButton.setAttribute('aria-pressed', String(next));
        wishlistButton.setAttribute('aria-label', next ? 'Remove from wishlist' : 'Add to wishlist');
        try { localStorage.setItem(wishlistKey, String(next)); } catch (error) {}
      });
    }

    var gallery = root.querySelector('[data-lnpd-gallery]');
    var galleryCount = root.querySelector('[data-lnpd-gallery-count]');
    if (gallery && galleryCount) {
      var mediaItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-lnpd-media]'));
      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          galleryCount.textContent = (Math.min(index + 1, mediaItems.length)) + ' / ' + mediaItems.length;
          ticking = false;
        });
      }, { passive: true });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;
        syncPurchaseState();
        if (addButton && addButton.disabled) {
          var target = sizing || root.querySelector('.lnpd-options');
          target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () {
            (target?.querySelector('[data-size-radio]:not([disabled]), [data-custom-required]:not([disabled]), [data-lnpd-option]:not([disabled])') || target?.querySelector('input:not([disabled]), button:not([disabled])'))?.focus({ preventScroll: true });
          }, 350);
          return;
        }
        if (form && addButton) form.requestSubmit(addButton);
      });
    }

    if (addButton) {
      new MutationObserver(syncPurchaseState).observe(addButton, { attributes: true, attributeFilter: ['disabled', 'data-sizing-locked', 'data-variant-locked'] });
    }
    form?.addEventListener('submit', function (event) {
      syncPurchaseState();
      if (root.dataset.sizingRequired !== 'true' || sizingIsValid()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (typeof sizing?.validate === 'function') sizing.validate({ focus: true });
      sizing?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    document.addEventListener('product-ajax:added', function () {
      window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('.lnmm-cart__count').forEach(function (count) { count.textContent = cart.item_count; });
          document.querySelectorAll('.lnmm-cart').forEach(function (link) { link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items'); });
          if (stickyButton) {
            stickyButton.textContent = 'Added to cart';
            window.setTimeout(syncSticky, 1400);
          }
        })
        .catch(function () {});
    });
    root.addEventListener('change', function () { window.setTimeout(syncPurchaseState, 0); });
    updateVariant(currentVariant, false);
    syncPurchaseState();
    window.setTimeout(syncPurchaseState, 0);
    window.setTimeout(syncPurchaseState, 250);
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-lnpd]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
